/**
 * ADR-109 — how each "open an Individual" entry point opens the Individual page.
 *
 *   AUTO — `/employees/:id`: the page resolves Edit or View with resolveIndividualOpenMode
 *          (the same rule as the Individuals list and the Project page).
 *   VIEW — `/employees/:id/view`: always read-only.
 *
 * EDIT is intentionally not an option: Edit is only ever reached through the resolver.
 * Switching a report back to read-only is a one-line change here.
 */
export const INDIVIDUAL_OPEN_MODES = Object.freeze({
  AUTO: 'auto',
  VIEW: 'view',
});

/** Resolved page modes (URL suffixes). */
export const INDIVIDUAL_PAGE_MODES = Object.freeze({
  EDIT: 'edit',
  VIEW: 'view',
});

export const INDIVIDUAL_ENTRY_POINTS = Object.freeze({
  BENCH_REPORT: 'benchReport',
  BENCH_REPORT_PLACEMENT_ACTIVITY: 'benchReportPlacementActivity',
  BENCH_ENTRY_LAG: 'benchEntryLag',
  BENCH_CANDIDATES: 'benchCandidates',
  FIXED_TERM_CONTRACTS: 'fixedTermContracts',
  DIRECT_MANAGER_DISCREPANCIES: 'directManagerDiscrepancies',
  INGESTION_SYNC_RUNS: 'ingestionSyncRuns', // ADR-133
  INTEGRITY_CHECKS: 'integrityChecks', // ADR-199
  ASSIGNMENT_COMPLETION_SERVICE_UNIT: 'assignmentCompletionServiceUnit',
});

export const INDIVIDUAL_OPEN_MODE_BY_ENTRY_POINT = Object.freeze({
  [INDIVIDUAL_ENTRY_POINTS.BENCH_REPORT]: INDIVIDUAL_OPEN_MODES.AUTO,
  // ?tab=PLACEMENT_ACTIVITY — Placement Activity behaves identically in either mode (ADR-009)
  [INDIVIDUAL_ENTRY_POINTS.BENCH_REPORT_PLACEMENT_ACTIVITY]: INDIVIDUAL_OPEN_MODES.AUTO,
  [INDIVIDUAL_ENTRY_POINTS.BENCH_ENTRY_LAG]: INDIVIDUAL_OPEN_MODES.AUTO,
  [INDIVIDUAL_ENTRY_POINTS.BENCH_CANDIDATES]: INDIVIDUAL_OPEN_MODES.AUTO,
  [INDIVIDUAL_ENTRY_POINTS.FIXED_TERM_CONTRACTS]: INDIVIDUAL_OPEN_MODES.AUTO,
  [INDIVIDUAL_ENTRY_POINTS.DIRECT_MANAGER_DISCREPANCIES]: INDIVIDUAL_OPEN_MODES.AUTO,
  [INDIVIDUAL_ENTRY_POINTS.INGESTION_SYNC_RUNS]: INDIVIDUAL_OPEN_MODES.AUTO,
  [INDIVIDUAL_ENTRY_POINTS.INTEGRITY_CHECKS]: INDIVIDUAL_OPEN_MODES.AUTO,
  [INDIVIDUAL_ENTRY_POINTS.ASSIGNMENT_COMPLETION_SERVICE_UNIT]: INDIVIDUAL_OPEN_MODES.AUTO,
});

/** Tab the Technology Configuration round-trip returns to (EmployeeForm TABS key). */
export const INDIVIDUAL_TECHNOLOGY_RADAR_TAB = 'COMPETENCIES';
